import "./App.css";
import { Route, Routes, BrowserRouter, redirect } from "react-router-dom";
import Header from "./components/Header";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import Maintenance from "./components/Maintenance";
function App() {
  // Redirect the user to the desired URL if they visit this site
  if (window.location.hostname !== "laghmam.com") {
    window.location.href = "https://laghmam.com/";
    return null; // Prevent rendering the rest of the app
  }
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Header />} />
          <Route path="/About" element={<About />} />
          <Route path="/Portfolio" element={<Portfolio />} />
          <Route path="/Contact" element={<Contact />} />
          {/* <Route path="*" element={<Maintenance />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;
